export default "__VITE_ASSET__QM$sVeJe__"